import React, { Component } from 'react'
import { Modal, Table, Icon, Card, Pagination } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'

import { API_GET_ORDER, API_GET_USER_EVENTS } from './../../../api'
import './order-detail.css'

const EVENT_TABLE_PAGE_SIZE = 5;

class OrderDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        paymentSource: {},
        activityLogs: [],
      },
      eventLog: {
        events: [],
        dataCount: 0,
        currentPage: 1,
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && this.props.orderId > 0 && this.props.orderId !== prevProps.orderId) {
      API_GET_ORDER(this.props.orderId).then(res =>
        this.setState({
          ...this.state,
          data: {
            ...res.data,
            activityLogs: res.data.activityLogs.map((x, i) =>
              ({ ...x, id: i })),
          },
        }))
    }

    if (this.props.visible && this.props.user != null && this.props.user !== prevProps.user) {
      this.updateEventLogTable()
    }
  }

  updateEventLogTable = (page = 1, pageSize = EVENT_TABLE_PAGE_SIZE) => {
    API_GET_USER_EVENTS(this.props.user.userId, { page: page, limit: pageSize }).then(res =>
      this.setState({
        ...this.state,
        eventLog: {
          events: res.data.userEvents,
          dataCount: res.data.count,
          currentPage: page,
        },
      }))
  }

  render() {
    const { visible, close, user } = this.props
    const { data, eventLog } = this.state
    const title = 'ORDER DETAIL'
    const columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
      }, {
        title: 'Time',
        dataIndex: 'time',
        key: 'time',
      }, {
        title: 'User',
        dataIndex: 'user',
        key: 'user',
      }, {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
      },
    ]

    const eventLogColumns = [
      {
        title: 'Events',
        dataIndex: 'event',
        key: 'event',
      },
      {
        title: 'Device name',
        dataIndex: 'device',
        key: 'device',
      },
      {
        title: 'Apps',
        dataIndex: 'appVersion',
        key: 'appVersion',
      },
      {
        title: 'IP',
        dataIndex: 'ip',
        key: 'ip',
      },
      {
        title: 'Timestamp',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: text => (
          <div>
            <div className="block">{moment(text).format('DD MMM YYYY, HH:mm')}</div>
          </div>
        ),
      },
    ]

    return (
      <Modal
        title={title}
        visible={visible}
        footer={null}
        onCancel={close}
        width={1200}
      >
        <div className="order-detail_summary">
          <div className="order-detail_summary-user">
            <table>
              <tbody>
                <tr>
                  <td>Penerima SMS</td>
                  <td>:</td>
                  <td>{data.notificationPhone}</td>
                </tr>
                <tr>
                  <td>Berita</td>
                  <td>:</td>
                  <td>{data.note}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="order-detail_summary-bank">
            <div className="order-detail_summary-bank-item">
              <div>Payment Source</div>
              <img className="order-detail_bank-img" src={data.paymentSource.image} alt="" />
              <div>{data.paymentSource.accountNo}</div>
              <div>{data.paymentSource.accountName}</div>
            </div>
            <div className="order-detail_summary-bank-separator">
              <Icon type="double-right" />
            </div>
            <div className="order-detail_summary-bank-item">
              <div>Destination</div>
              <img className="order-detail_bank-img" src={data.image} alt="" />
              <div>{data.destinationBankNo}</div>
              <div>{data.ownerName}</div>
            </div>
          </div>
        </div>
        <h4>Activity Log</h4>
        <Table rowKey="id" dataSource={data.activityLogs} columns={columns} pagination={false} />
        <br />

        <span>
          <h4 style={{ float: 'left' }}>{eventLog.dataCount} events found.</h4>
          <h4 style={{ textAlign: 'right' }}>Phone number: {user && user.phone}</h4>
        </span>
        <div>
          <Card className="table-responsive">
            <div>
              <Table
                dataSource={eventLog.events}
                columns={eventLogColumns}
                rowKey="id"
                pagination={false}
              />
              <div className="app-pagination">
                <Pagination
                  current={eventLog.currentPage}
                  total={eventLog.dataCount}
                  onChange={this.updateEventLogTable}
                  pageSize={EVENT_TABLE_PAGE_SIZE}
                />
              </div>
            </div>
          </Card>
        </div>
      </Modal>
    )
  }
}

OrderDetail.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired,
}

export default OrderDetail



// WEBPACK FOOTER //
// src/pages/order/order-detail/index.js